// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonAuth = {
  username: "用户名",
  password: "密码",
  captcha: "验证码",
  currentPassword: "当前密码",
  newPassword: "新密码",
  confirmNewPassword: "确认新密码",
  localLogin: "本地登录",
  hybridLogin: "统一身份优先（兼容本地登录）",
  ssoLogin: "统一身份登录",
} as const;
